import { Pin } from '@carbon/icons-react'
import { Button } from 'app/_components/Button'
import {
  Dialog,
  DialogAbort,
  DialogContent,
  DialogOverlay,
  DialogPortal,
  DialogSubmit,
  DialogTitle,
  DialogTrigger,
} from 'app/_components/Dialog'
import { Combobox } from 'app/_components/Form/Combobox'
import { Field } from 'app/_components/Form/Field'
import { Form } from 'app/_components/Form/Form'
import { addStoriesToChannel } from './actions'

export type AddStoryDialogProps = {
  channelId: string
  disabled?: boolean
  className?: string
  open?: boolean
  onOpenChange?: (open: boolean) => void
}

export default function AddStoryDialog({
  channelId,
  disabled,
  className,
  open,
  onOpenChange,
}: AddStoryDialogProps) {
  const title = 'Beitrag anpinnen'

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {open === undefined && (
        <DialogTrigger
          Trigger={
            <Button variant="default" className={className} disabled={disabled}>
              {title} <Pin className="h-4 w-4" aria-hidden="true" />
            </Button>
          }
        />
      )}
      <DialogPortal>
        <DialogOverlay>
          <DialogContent
            className="overflow-visible xl:w-[600px]"
            contentClassName="overflow-visible"
            aria-describedby="add-story-modal-description"
          >
            <DialogTitle>{title}</DialogTitle>
            <Form
              action={addStoriesToChannel.bind(null, channelId)}
              className="form-fields-gray"
            >
              <div className="mb-8 flex flex-col justify-center gap-4">
                <p id="add-story-modal-description">
                  Wähle einen oder mehrere Beiträge aus, um diese anzupinnen.
                </p>
                <div className="relative overflow-visible!">
                  <Field label="Beiträge" name="story[]">
                    <Combobox
                      route={`/api/suggestions/stories?ignore-channel=${channelId}`}
                      required
                      placeholder={{ title: 'Option(en) auswählen' }}
                      multiple
                    />
                  </Field>
                </div>
              </div>
              <DialogAbort>Abbrechen</DialogAbort>
              <DialogSubmit>Hinzufügen</DialogSubmit>
            </Form>
          </DialogContent>
        </DialogOverlay>
      </DialogPortal>
    </Dialog>
  )
}
